const initialState = {
    count: 0,
    catalog: [],
    isReadingCatalog: false,
    summaries: {},
    catalog_discounts: []
}

export default initialState;
